export default __webpack_public_path__ + "static/media/whatsapp.eb20681d.png";